import { render, staticRenderFns } from "./DonutChart08.vue?vue&type=template&id=4ffe6b32&scoped=true"
import script from "./DonutChart08.vue?vue&type=script&lang=js"
export * from "./DonutChart08.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffe6b32",
  null
  
)

export default component.exports